import React from 'react';
import './SubmissionEntry.css'

const SubmissionEntry = (props) => (
    <div className="SubmissionEntry">
        <div className="SubmissionEntryText">{props.original} ➔ {props.translation}</div>
        {props.existing && (<div className="SubmissionEntryStrike">{props.existing}</div>)}
        <a href="#" className="SubmissionEntryReject" onClick={props.rejectEntryListener}>Reject entry</a>
    </div>
);

export default SubmissionEntry;